import React, { useEffect, useState, useCallback } from "react";
import { Bell } from "lucide-react";

/**
 * Top-nav inbox bell. Polls /support/unread and shows a badge when a borrower,
 * broker, or teammate has sent an unread message. Clicking scrolls to the
 * Support Inbox / Messages panel on the page.
 */
export const InboxBell = ({ client, accent = "#B8860B", targetSelector = '[data-testid="support-panel"]', extraUnreadUrl = null }) => {
  const [count, setCount] = useState(0);

  const load = useCallback(async () => {
    try {
      const reqs = [client.get("/support/unread")];
      if (extraUnreadUrl) reqs.push(client.get(extraUnreadUrl));
      const res = await Promise.all(reqs);
      const total = res.reduce((sum, r) => sum + Number(r.data?.count || 0), 0);
      setCount(total);
    } catch { /* noop */ }
  }, [client, extraUnreadUrl]);

  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [load]);

  const go = () => {
    const el = document.querySelector(targetSelector) || document.getElementById("sec-support");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    // give the list a beat, then refresh the count (opening a thread clears it)
    setTimeout(load, 2500);
  };

  return (
    <button onClick={go} data-testid="inbox-bell" aria-label="Messages"
      title={count > 0 ? `${count} new message${count > 1 ? "s" : ""}` : "Messages"}
      className="relative inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-white/10 transition-colors">
      <Bell size={17} style={{ color: count > 0 ? accent : "#9A9A90" }} />
      {count > 0 && (
        <span data-testid="inbox-bell-badge"
          className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] px-1 flex items-center justify-center text-[9px] font-bold rounded-full text-black"
          style={{ background: accent }}>
          {count > 9 ? "9+" : count}
        </span>
      )}
    </button>
  );
};

export default InboxBell;
